import { render, staticRenderFns } from "./PackageInfo.vue?vue&type=template&id=76c856dd"
import script from "./PackageInfo.vue?vue&type=script&lang=js"
export * from "./PackageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports